<script lang="ts">
	import { T } from '@tolgee/svelte';

	export let titleTolgeeKey: string | undefined = undefined;
	export let contentTolgeeKey: string | undefined = undefined;
	export let title: string | undefined | null = undefined;
	export let contentItems: Array<string | undefined | null> | undefined | null = undefined;
	export let editLink: string | undefined = undefined;
	export let changePasswordLink: string | undefined = undefined;
</script>

<div
	class="flex flex-col gap-1 max-w-[26.650625rem] text-gray-600 rounded-lg border border-gray-300 px-4 py-5 bg-white"
>
	<span class="font-semibold text-black text-h-16">
		{#if titleTolgeeKey}
			<T keyName={titleTolgeeKey} />
		{:else if title}
			{title}
		{/if}
	</span>
	<span>
		{#if contentTolgeeKey}
			<T keyName={contentTolgeeKey} />
		{:else if contentItems && contentItems.length > 0}
			<div class="flex flex-col gap-0.5">
				{#each contentItems as contentItem}
					<span>{contentItem}</span>
				{/each}
			</div>
		{/if}
	</span>

	<div class="flex flex-row w-full mt-6 gap-11 !font-semibold">
		{#if editLink}
			<a href={editLink} class="text-accent-primary text-h-14 hover:underline">
				<T keyName="edit" />
			</a>
		{/if}
		{#if changePasswordLink}
			<a href={changePasswordLink} class="text-accent-primary text-h-14 hover:underline">
				<T keyName="changePassword.title" />
			</a>
		{/if}
	</div>
</div>
